import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { IPlanFeedbackGenericSlotBuilder } from '../../builders/plan_feedback_generic_slot_builder';
import {
  ApPlanFeedbackDeEmphasizeEventNameStrategy,
  ApPlanFeedbackEmphasizeEventNameStrategy
} from '../../strategies/plan_feedback_highlight_event_name_strategy';

class PlanFeedbackTermCourseTileController {
  private course: IPlanFeedbackGenericSlotBuilder;
  private uniqueId: string;
  private emphasizeMeBound: () => void;
  private deEmphasizeMeBound: () => void;
  private classNameForEmphasizing = ' ap-plan-feedback-hover-class';

  constructor(private ngComponentCommunicatorService: CommunicatorService) {}

  emphasizeMe() {
    if (!this.course.cssClasses.includes(this.classNameForEmphasizing)) {
      this.course.cssClasses += this.classNameForEmphasizing;
    }
  }

  deEmphasizeMe() {
    this.course.cssClasses = this.course.cssClasses.replace(this.classNameForEmphasizing, '');
  }

  $onInit() {
    this.uniqueId = _4.uniqueId();
    this.emphasizeMeBound = this.emphasizeMe.bind(this);
    this.deEmphasizeMeBound = this.deEmphasizeMe.bind(this);
    this.ngComponentCommunicatorService.subscribe(
      ApPlanFeedbackEmphasizeEventNameStrategy['COURSE'](this.course.transactionNk),
      this.emphasizeMeBound
    );
    this.ngComponentCommunicatorService.subscribe(
      ApPlanFeedbackDeEmphasizeEventNameStrategy['COURSE'](this.course.transactionNk),
      this.deEmphasizeMeBound
    );
  }
}

angular.module('capability-ng-academic-planner').component('planFeedbackTermCourseTile', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_term_course_tile/plan_feedback_term_course_tile.html',
  bindings: {
    course: '<'
  },
  controller: PlanFeedbackTermCourseTileController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_term_course_tile/plan_feedback_term_course_tile.ts